module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"attach_new_document":"Create Note","table.results":"Results per page:","table.newer":"Newer","table.older":"Older"},"fr":{"attach_new_document":"Joindre un nouveau document"}}')
  delete Component.options._Ctor
}
